import { EnumResponse, IBankModel, IRiskAddressModel, Result } from '@/types/base';
import { AgGridRequest, BshCurrency } from '@/types/models';
import { Moment } from 'moment';
import { ResponseError } from 'umi-request';
import request from './request';

class Services {
    // Some fake data
    public static async fakeChartData(): Promise<{ data: { visitData: { x: string; y: number }[] } }> {
        return request('/fakes/fake_analysis_chart_data');
    }

    // List of risk addresses
    public static async getAllRiskAddressAg(params: AgGridRequest): Promise<Result<IRiskAddressModel[]>> {
        return request('/riskaddress/ag', {
            method: 'POST',
            data: params,
        });
    }

    public static async getAgendaMotor(data: { startDate: Moment | null; endDate: Moment | null }) {
        return request('/agenda/motor', {
            method: 'POST',
            data,
        });
    }

    public static async getCurrencies(): Promise<Result<BshCurrency[]>> {
        return request('/currency/rates');
    }

    public static async getSpecificEnum(name: string): Promise<EnumResponse[]> {
        return request(`/enum/${name}`);
    }

    public static async getBankList(): Promise<Result<IBankModel[]>> {
        return request('/bank/list');
    }

    public static async getGithubActionsRuns(): Promise<{ total_count: number }> {
        return request('/github', {
            errorHandler: (e: ResponseError | any) => {
                throw e;
            },
        });
    }

    public static async getClaimsByCustomer(nid: string, signal?: AbortSignal): Promise<Result<any[]>> {
        return request(`/interop/interop/claims-by-customer?nid=${nid}`, { errorHandler: (e: ResponseError | any) => {}, signal });
    }

    public static async getSalesByCustomer(nid: string, signal?: AbortSignal): Promise<Result<any[]>> {
        return request(`/interop/interop/sales-by-customer?nid=${nid}`, { errorHandler: (e: ResponseError | any) => {}, signal });
    }

    public static async getDebitByCustomer(nid: string, signal?: AbortSignal): Promise<Result<any[]>> {
        return request(`/interop/interop/debit-by-customer?nid=${nid}`, {
            errorHandler: (e: ResponseError | any) => {},
            signal,
        });
    }
}

export default Services;
